<template xmlns:v-el="https://www.w3.org/1999/xhtml">
    <div id="TopSearch" class="{{searchFixed}}">
        <div id="searchBlur" v-if="searchtype == 'searchManage'">
            <form @submit.prevent="onSubmit">
                <input type="text" v-el:searchblur  v-model="keyword" placeholder="请输入物品名称等关键词" name="keyword"  @keyup="onKeywordChange" autocomplete="off" id="searchM" >
            </form>
            <span class="top-search-cancel" @click="hide()">取消</span>
        </div>
        <div id="searchRouter" v-if="searchtype == 'searchRouter'">
            <div type="text"  autocomplete="off" class="fake-input" @click="goSearchManage()">
            <i class="icon_search"></i>{{keyword}}
            </div>
            <a class="top-search-message" v-link="{ name: 'message'}"><span class="info-num" v-if="numAll | messageNumFilter"></span></a>
        </div>
        <!--<div id="searchClick" v-if="searchtype == 'searchClick'">
            <form @submit="blur(keyword)">
                <input type="text" v-el:keyword v-model="message" placeholder="请输入物品名称等关键词" name="keyword" autocomplete="off">
                <button type="submit">搜索</button>
            </form>
        </div>-->
        <div v-show = "searchSuggest.length > 0" class="search-suggest">
            <ul>
                <li v-for="item in searchSuggest" @click="onSuggestClick(item.k)" >{{item.k}}</li>
            </ul>
        </div>
    </div>
</template>
<style lang="less">
   @import "TopSearch.less";
</style>
<script>
    var Vue = require('vue');
    var Cookies = require('../../libs/cookie');
    var localStore = require('../../libs/store').local;
    var isLogin = require('../../mixins/login').mixin.methods.isLogin;
    module.exports = {
        data:function(){
            return {
                searchSuggest:[],
                numAll:0,
                commentmsgnum:0,
                ordermsgnum:0,
                chatmsgnum:0,
                systemmsgnum:0,
                source:24,
                loginFlag:false,
                uid:""
            }
        },
        filters:{
            messageNumFilter:function(num){
                if(num == 0){
                    return false;
                }else{
                    return true;
                }
            }
        },
        methods:{
            onSubmit:function(){
                var keyword = this.keyword.trim();
                if(keyword.length>0){
                    this.$dispatch('toHideManager');
                    this.$nextTick(function(){
                        document.getElementById('searchM').blur();
                    })
                    this.$router.go({name:'search',params:{keyword:keyword}});
                }
            },
            getInformation:function() {
                    var self = this;
              //判断到家登陆状态，获取ZZU
                    if(isLogin()) {
                      //每次调用getInformation方法清空numAll，否则上次的结果会带到下次。
                      this.numAll= 0;
                      //获取未读评论信息数量
                      this.$http.jsonp("getUnreadInfoCommentsCount").then ( function(response1) {
                        if(response1.data.respCode == "0" && !!response1.data.respData){
                            var commentmsgnum =  parseInt(response1.data.respData.count, 10);
                            this.numAll += commentmsgnum;
                            //如果numAll>0的话，就退出函数，因为我们要的只是红点，不是具体数量。
                            if (this.numAll) {
                              return this.numAll
                            }
                            //获取订单数量
                            this.$http.jsonp("getOrderUnread").then ( function(response){
                            if(response.data.respCode == "0" && !!response.data.respData){
                                var ordermsgnum = parseInt(response.data.respData.cnt);
                                this.numAll += ordermsgnum;
                                if (this.numAll) {
                                  return this.numAll
                                }
                                //判断IM的登陆状态，如果未登录则先登陆，否则直接调用getChatAndSystemMsgNum方法。
                                if (!this.loginFlag){
                                  console.log('not login');
                                  var url = "//grzhuanzhuan.58.com/user_login";
                                  var params = {
                                      uid : this.uid,
                                      source : this.source,
                                      pc_code: "weixin",
                                      client_version: "1.0.0"
                                  };
                                 this.$http.jsonp(url,params).then ( function (response) {
                                    if(response.data.code == "200000") {
                                      this.loginNum =0;
                                      this.loginFlag = true;
                                      this.getChatAndSystemMsgNum();
                                    }
                                  });
                                }else {
                                  console.log('already login');
                                  this.getChatAndSystemMsgNum();
                                }
                            }
                          },function(response){
                              // error callback
                              console.log("fail" + response.status);
                          });
                        }
                      },function(response){
                          // error callback
                          console.log("fail" + response.status);
                      })
                  }else {
                    console.log('isLogin is false');
                  }
            },
            getChatAndSystemMsgNum:function(){
                /*获取离线私信消息数*/
                var chatMsgList = localStore.get("chatList") ? localStore.get("chatList") : {};
                var num = 0;
                var chatMsgObj = !!chatMsgList[this.uid] ? chatMsgList[this.uid] : {};
                for(var key in chatMsgObj){
                    num += (chatMsgObj[key] ? chatMsgObj[key] : 0);
                }
                self.chatmsgnum = num;
                this.numAll += (+self.chatmsgnum);
                if (this.numAll) {
                  return this.numAll;
                }
                var url = "//grzhuanzhuan.58.com/getofflinemsgcount";
                var params = {
                    source : this.source,
                    uid : this.uid,
                    msgtype : 10
                };
                params.msgtype = 39;
                this.$http.jsonp(url,params).then( function(response){
                    if(response.data.code == "200000"){
                        self.systemmsgnum = parseInt(response.data.protocol_content.msg_count);
                        this.numAll += (+self.systemmsgnum);
                        if (this.numAll) {
                          return this.numAll;
                        }
                    }
                },function(response){
                    // error callback
                    console.log("fail" + response.status);
                });
            },
            onKeywordChange : function(){
                var keyword = this.keyword.trim();
                if( keyword ){
                    this.$http.jsonp('searchSuggest',{inputText:keyword}).then(function(response){
                        if(response.data.respCode == 0){
                            this.searchSuggest = response.data.respData || [];
                        }else{
                            this.searchSuggest = [];
                        }
                    });
                }
                else{
                    this.searchSuggest = [];
                }
            },
            goSearchManage:function(){
                this.$dispatch('toShowManger');
                this.$nextTick(function(){
                    document.getElementById('searchM').focus();
                })
            },
            onSuggestClick:function(keyword){
                this.keyword = keyword;
                if(keyword.trim().length>0){
                    this.$router.go({name:'search',params:{keyword:keyword},replace:true});
                }
            },
            hide:function(){
                //history.back();
                this.$dispatch('toHideManager');

            }
        },
        props:{
            searchtype : {
                type : String
            },
            keyword : {
                type : String,
                default : ''
            }
        },
        ready:function(){this.searchSuggest = []},
        events: {
          getInformation : function() {
            console.debug('uid',Cookies.getUID());
            this.uid = Cookies.getUID() || '';
            this.getInformation();
          }
        }

    }
</script>



/** WEBPACK FOOTER **
 ** TopSearch.vue?181c9a5c
 **/